import { newTracker } from '@snowplow/browser-tracker';
import { FormTrackingPlugin } from '@snowplow/browser-plugin-form-tracking';
import { TimezonePlugin } from '@snowplow/browser-plugin-timezone';
import { COOKIE_DOMAIN, COOKIE_NAME } from './constants';

export default ({
  trackerName,
  collectorUrl,
  forceSecureTracker,
  anonymousTracking = false,
  appId,
}) => {
  newTracker(trackerName, collectorUrl, {
    appId,
    contexts: {
      webPage: true,
    },
    cookieDomain: COOKIE_DOMAIN,
    cookieName: COOKIE_NAME,
    forceSecureTracker,
    platform: 'web',
    post: true,
    anonymousTracking,
    respectDoNotTrack: true,
    userFingerprint: false,
    plugins: [
      FormTrackingPlugin(),
      TimezonePlugin(),
    ],
  });
};
